
const isDirectionRTL = () => {
    const lang = JSON.parse(localStorage.getItem('lang'));
    if (!lang || !lang.locale ) {
        console.log("Language setting not found, defaulting to LTR");
        
        return true;
    }
    return lang.locale === 'ar';
};

export default isDirectionRTL;